import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";

// Eager metadata registration; the render component (EventList) code-splits into
// its own tpl-event-list chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'event-list',
    name: 'Event List',
    description: 'A list widget to show upcomming events.',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-event-list" */ "./EventList")),
    icon: ['fas', 'clipboard-list-check'],
    complexity: 'medium',
    canDragDropFields: true,
    expectedSchema: 'dictionary-array',
})
